import { render, staticRenderFns } from "./patent.vue?vue&type=template&id=60d126d0&scoped=true"
import script from "./patent.vue?vue&type=script&lang=js"
export * from "./patent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d126d0",
  null
  
)

export default component.exports